export default __webpack_public_path__ + "static/media/022-ice cream cone.337d3e37.svg";